import { Injectable } from '@angular/core';
import {
    IQuotationCost,
} from "libraries/service/resources/quotation-quotations/IQuotationsQuotation";
import { FormBuilder, FormGroup } from "@angular/forms";

@Injectable()
export class CostFormGeneratorService {

    constructor(private readonly formBuilder: FormBuilder) {
    }

    public generateCostGroup(cost: IQuotationCost): FormGroup {
        return new FormGroup({
            currency: this.formBuilder.control(
                cost ?
                    Array.isArray(cost.currency) ?
                        cost.currency :
                        [cost.currency] :
                    ["EUR"]),
            value: this.formBuilder.control(cost ? cost.value : null),
            amount: this.formBuilder.control(cost ? cost.amount : null),
            decimals: this.formBuilder.control(cost && cost.decimals ? cost.decimals : 2),
        }, {updateOn: "blur"});
    }

    public generateLabelGroup(titleData?: string): FormGroup {
        return new FormGroup({
            title: this.formBuilder.control(titleData ? titleData : "")
        }, {updateOn: "blur"});
    }

}
